<template>
<el-row>
   <headertop></headertop>
   <div class="all" ref="father_file">
     <span style="cursor: pointer;color: blue;" @click="out()">返回</span>
    <div class="con">
      <div>
        <div>
           <iframe :src="file.url" frameborder="0" :height="height" style="width:100%;"></iframe>
        </div>
      </div>
    </div>
   </div>
   <footerbom></footerbom>
</el-row>
</template>


<script>
    import Header from '../../../components/index/public/visitor_NavHeader.vue';
  import Footer from '../../../components/index/public/NavFooter.vue';
  import pdf from 'vue-pdf'
  export default {
    name: 'App',
    data() {
      return {
        file:{
          url:this.$route.query.file,
        },
        height:'',
      }
    },
    components: {
      headertop: Header,
      footerbom: Footer,
      pdf
    },
    mounted:function(){
     this.change_height()
    },
    methods: {
      out(){
        window.close()
      },
      change_height(){
        let _this=this
        let fatherH = _this.$refs.father_file.offsetHeight
        _this.height=fatherH  + 'px'
      },
  }}
</script>

<style scoped>
 
.all{
  min-height: calc(100vh - 330px);
  width: 62%;
  padding: 20px;
  margin: 0 15%;
  z-index: 100;
  background-color: white;
  overflow: hidden;
}

.con{
  margin-top: 1.5rem;
}

</style>



// WEBPACK FOOTER //
// src/view/visitor/Courses/video_file.vue